import React, { FunctionComponent } from 'react';
import { DoubleFeaturedArticlesPage } from '.';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { ArticlePreview } from '../../../types/articlePreview';
import { urlFor } from '../../../utils/imageBuilder';
import ArticleCard from '../../ArticleCard';
import { InternalLinkIcon } from '../../Icons';
import InternalLink from '../../InternalLink';

type ArticlePageTeaserProps = {
  page: DoubleFeaturedArticlesPage;
  articles: ArticlePreview[];
}


const ArticlePageTeaser: FunctionComponent<ArticlePageTeaserProps> = ({ page, articles }) => {
  const { isMobile } = useScreenSize();
  const imgSrc = page.teaser?.image?.asset || page.image?.asset ? page.teaser?.image ? page.teaser?.image : page.image! : null;

  return (
    <div className='teaser' >
      {!isMobile && imgSrc && (
        <img
          src={urlFor(imgSrc).width(650).quality(100).url()}
          alt={imgSrc.alt}
        />
      )}
      <div className='teaser-header'>
        <div className='teaser-header-texts'>
          <h2>{page.teaser?.title ? page.teaser.title : page.title}</h2>
          {page.teaser?.description && (
            <p>{page.teaser.description}</p>
          )}
        </div>
        <InternalLink
          reference={page}
        >
          <InternalLinkIcon />
        </InternalLink>
      </div>

      <div className='teaser-articles'>
        {articles.map((article) => (
          <ArticleCard key={article._id} article={article} />
        ))}
      </div>
      {!isMobile && (

        <InternalLink
          reference={page}
          className='primary-button'
        >
          {page.teaser?.cta ? page.teaser.cta : 'See all news'}
          <InternalLinkIcon />
        </InternalLink>
      )}
    </div>
  )
}

export default ArticlePageTeaser;
